// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pricing_content-module__container--3DB6G{width:350px;height:260px}.pricing_content-module__header--ohZV9{text-align:center;border-bottom:1px solid #cccccc;padding:24px 16px;font-size:16px}.pricing_content-module__header--ohZV9__title{margin-bottom:12px}.pricing_content-module__content--rFtWu{padding:24px 24px 8px 24px}.pricing_content-module__title--WPdJU{font-size:16px;font-weight:bold;line-height:24px}.pricing_content-module__speech--1ALQe{font-size:14px;margin-top:8px;line-height:21px;white-space:pre-line;overflow:hidden}.pricing_content-module__link--2JDAN{margin-top:16px;font-size:16px;color:#36b}\n", ""]);
// Exports
exports.locals = {
	"container": "pricing_content-module__container--3DB6G",
	"header": "pricing_content-module__header--ohZV9",
	"content": "pricing_content-module__content--rFtWu",
	"title": "pricing_content-module__title--WPdJU",
	"speech": "pricing_content-module__speech--1ALQe",
	"link": "pricing_content-module__link--2JDAN"
};
module.exports = exports;
